const numDistricts = 23
const districts = Array(numDistricts)
  .fill(1)
  .map((x, y) => x + y)

export default districts
